import { CompareFn } from '../services/compare.factory';

export const sortFieldValues = <
  T extends {
    values: Array<{ value: string; isEnabled: boolean }>;
  },
>(
  field: T,
  compare: CompareFn,
  opts?: { removeDisabled?: boolean },
): T => {
  if (opts?.removeDisabled) {
    field.values = field.values.filter(fv => fv.isEnabled);
  }

  field.values.sort((a, b) => {
    if (a.isEnabled !== b.isEnabled) {
      return a.isEnabled ? -1 : 1;
    }
    return compare(a.value, b.value);
  });

  return field;
};
